import React from 'react'
import { OrganizationItemProps } from '../types'
import { Typography, ListItemButton, SvgIcon } from '@mui/material'
import { ReactComponent as PushPin } from '../../../assets/images/PushPin.svg'

export const OrganizationItem: React.FC<OrganizationItemProps> = ({
    organization,
    isDarkMode,
    isFavorite,
    onSelect,
}) => (
    <ListItemButton
        key={organization._id}
        sx={{ '&:hover': { backgroundColor: 'figma.grayscale.tier5' } }}
        className={'organization-item'}
        onClick={() => onSelect(organization._id)}
    >
        {organization.image && (
            <img
                src={isDarkMode ? organization.image : organization.lightModeImage}
                alt={`${organization.name} Logo`}
                className="org-list-logo"
            />
        )}
        <Typography className="org-name">{organization.name}</Typography>
        {isFavorite && (
            <Typography className="favorite-star">
                <SvgIcon
                    component={PushPin}
                    inheritViewBox
                    fontSize="small"
                    color="inherit"
                    sx={{ fontSize: '20px' }}
                />
            </Typography>
        )}
    </ListItemButton>
)
